import { timeInterval as o } from "./interval.js";
import { durationMinute as n, durationDay as r } from "./duration.js";
const a = o(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * n) / r,
  (t) => t.getDate() - 1
);
a.range;
const s = o((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / r, (t) => t.getUTCDate() - 1);
s.range;
const u = o((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / r, (t) => Math.floor(t / r));
u.range;
export {
  a as timeDay,
  u as unixDay,
  s as utcDay
};
